export const RECHARGE_ROUTES_URL = {
  WALLET: '/recharge-requests/wallet',
  BOSTA_CREDITS: '/recharge-requests/bosta-credits'
};
